import { createComponent } from '@carvana/merch-components';

export const Details = createComponent('span', {
  className:
    'mt-auto inline-block text-text-primary no-underline t-label-sm hover:text-text-primary-hover'
});

export const ImageryCard = createComponent('div', {
  className:
    'group flex h-full w-[300px] cursor-pointer flex-col overflow-hidden rounded-md border border-border-subtle bg-background-default md:w-[268px] lg:w-[226px] xl:w-[240px]'
});

export const ImageryCardContent = createComponent('div', {
  className: 'flex flex-1 flex-col gap-lg p-2xl'
});

export const ImageryWrapper = createComponent('div', {
  className: 'relative w-full shrink-0 overflow-hidden aspect-video'
});

export const StyledImage = createComponent('img', {
  className:
    'w-full h-full rounded-t-md object-cover transition-transform duration-200 ease-in-out group-hover:scale-110'
});
